import ScreenContainer from '../../display/ui/ScreenContainer';
import { FONT_TITLE } from '../../constants/AppConstants';
import { GetDefaultButtonCostume } from '../hud/HudConstants';
import Hud from '../hud/Hud';

export default class TutorialOverlay extends ScreenContainer {
  constructor(game, tutorial, model = true) {
    super(game, { modal: model });

    this.tutorials = tutorial;

    this.onComplete = new Phaser.Signal();

    this.panelWidth = 697;
    this.panelHeight = 429;
    this.tutorialIndex = 0;
    this.showCurrentTutorial();
  }

  handleNextTutorial() {
    this.tutorialIndex++;
    this.showCurrentTutorial();
  }

  showCurrentTutorial() {
    if (this.tutorialPanel) {
      this.clearTutorialPanel(this.tutorialPanel);
    }
    const tutorial = this.tutorials[this.tutorialIndex];

    this.tutorialPanel = this.createTutorialPanel(
      tutorial.copy,
      tutorial.image,
      this.tutorialIndex == this.tutorials.length - 1
    );
    this.tutorialPanel.x = this.game.defaultWidth * 0.5 - this.panelWidth * 0.5;
    this.tutorialPanel.y = this.game.defaultHeight * 0.5 - this.panelHeight * 0.5;
    this.add(this.tutorialPanel);
  }

  createTutorialPanel(copy, image, isFinal) {
    const panel = this.game.make.group();

    // dh -  quick and dirty fix for https://jira.jollywise.co.uk/browse/SDTG-138
    // add input blocking graphic to disable suitcase ( initially tried to disable button but it was still enabled at this point )
    const inputBlocker = this.game.make.graphics();
    inputBlocker.beginFill(0xff0000, 0);
    inputBlocker.drawRoundedRect(
      -this.game.defaultWidth * 0.5,
      0,
      this.game.defaultWidth,
      this.game.defaultHeight,
      30
    );
    inputBlocker.inputEnabled = true;
    panel.addChild(inputBlocker);

    const backing = this.game.make.graphics();
    backing.beginFill(0x000000, 0.25);
    backing.drawRoundedRect(0, 20, this.panelWidth, this.panelHeight, 30);
    backing.beginFill(0xffffff, 1);
    backing.drawRoundedRect(0, 0, this.panelWidth, this.panelHeight, 30);
    panel.addChild(backing);

    const imageSprite = this.game.make.image(0, 0, image);
    imageSprite.anchor.set(0.5);
    imageSprite.x = this.panelWidth * 0.5;
    imageSprite.y = this.panelHeight * 0.5;
    panel.addChild(imageSprite);

    const title = this.game.make.text(0, 0, copy, {
      font: '43px ' + this.game.titleFontStyle,
      fill: '#0090C1',
      wordWrap: true,
      wordWrapWidth: this.panelWidth,
      boundsAlignH: 'center',
      boundsAlignV: 'middle',
    });
    title.lineSpacing = -10;
    title.setTextBounds(0, 0, this.panelWidth, 80);
    panel.add(title);

    // add panel button

    const panelCostume = GetDefaultButtonCostume(isFinal ? 'close' : 'rightarrow');
    const panelButton = Hud.CreateHudButton(panelCostume, this.game);
    panelButton.onInputDown.add(isFinal ? this.handleCloseTutorial : this.handleNextTutorial, this);
    panelButton.anchor.set(0.5);
    panelButton.x = this.panelWidth;
    panel.add(panelButton);

    panel.button = panelButton;

    return panel;
  }

  clearTutorialPanel(panel) {
    panel.button.onInputDown.removeAll();
    panel.button.destroy(true);
    panel.destroy(true);
  }

  handleCloseTutorial() {
    this.visible = false;
    this.onComplete.dispatch();
  }

  destroy() {
    this.clearTutorialPanel(this.tutorialPanel);
    this.tutorialPanel = null;
    this.tutorials = null;
    this.tutorialIndex = null;
    this.panelHeight = null;
    this.panelWidth = null;
    super.destroy();
  }
}



// WEBPACK FOOTER //
// ./js/app/ui/tutorial/TutorialOverlay.js